import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import i18n from '../i18n/config';

const Contact: React.FC = () => {
  return (
    <section id="contact" className="py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-[#2c3e50] sm:text-4xl">
            {i18n.t('contact.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <a 
            href={`tel:${i18n.t('contact.phone')}`}
            className="bg-white rounded-lg p-6 text-center hover:bg-[#3498db]/5 transition-colors duration-200 border border-[#3498db]/10 hover:border-[#3498db]/30 shadow-lg"
          >
            <div className="flex justify-center mb-4">
              <Phone className="h-8 w-8 text-[#3498db]" />
            </div>
            <h3 className="text-lg font-medium text-[#2c3e50] mb-2">
              {i18n.t('contact.phone_title')}
            </h3>
            <p className="text-[#2c3e50]/80">
              {i18n.t('contact.phone')}
            </p>
          </a>

          <a 
            href={`mailto:${i18n.t('contact.email')}?subject=Jautājums no mājaslapas`}
            className="bg-white rounded-lg p-6 text-center hover:bg-[#1abc9c]/5 transition-colors duration-200 border border-[#1abc9c]/10 hover:border-[#1abc9c]/30 shadow-lg"
          >
            <div className="flex justify-center mb-4">
              <Mail className="h-8 w-8 text-[#1abc9c]" />
            </div>
            <h3 className="text-lg font-medium text-[#2c3e50] mb-2">
              {i18n.t('contact.email_title')}
            </h3>
            <p className="text-[#2c3e50]/80">
              {i18n.t('contact.email')}
            </p>
          </a>

          <a 
            href={`https://waze.com/ul?q=${encodeURIComponent(i18n.t('contact.address'))}`}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white rounded-lg p-6 text-center hover:bg-[#f1c40f]/5 transition-colors duration-200 border border-[#f1c40f]/10 hover:border-[#f1c40f]/30 shadow-lg"
          >
            <div className="flex justify-center mb-4">
              <MapPin className="h-8 w-8 text-[#f1c40f]" />
            </div>
            <h3 className="text-lg font-medium text-[#2c3e50] mb-2">
              {i18n.t('contact.address_title')}
            </h3>
            <p className="text-[#2c3e50]/80">
              {i18n.t('contact.address')}
            </p>
          </a>

          <div className="bg-white rounded-lg p-6 text-center border border-[#2c3e50]/10 shadow-lg">
            <div className="flex justify-center mb-4">
              <Clock className="h-8 w-8 text-[#2c3e50]" />
            </div>
            <h3 className="text-lg font-medium text-[#2c3e50] mb-2">
              {i18n.t('contact.hours_title')}
            </h3>
            <p className="text-[#2c3e50]/80">
              {i18n.t('contact.hours_weekdays')}<br />
              {i18n.t('contact.hours_weekend')}
            </p>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-[#2c3e50]/80">
            {i18n.t('contact.additional_info')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact; 